import { BaseObserver } from '@powersync/common';
import { Mutex, LockType } from '@powersync/shared-internals';
export class SSRStreamingSyncImplementation extends BaseObserver {
    syncMutex;
    crudMutex;
    isConnected;
    lastSyncedAt;
    constructor() {
        super();
        this.syncMutex = new Mutex();
        this.crudMutex = new Mutex();
        this.isConnected = false;
    }
    obtainLock(lockOptions) {
        const mutex = lockOptions.type == LockType.CRUD ? this.crudMutex : this.syncMutex;
        return mutex.runExclusive(lockOptions.callback, lockOptions.signal);
    }
    /**
     * This is a no-op in SSR mode
     */
    async connect() { }
    async dispose() { }
    /**
     * This is a no-op in SSR mode
     */
    async disconnect() { }
    /**
     * This SSR Mode implementation is immediately ready.
     */
    async waitForReady() { }
    /**
     * This will never resolve in SSR Mode.
     */
    waitUntilStatusMatches(_predicate) {
        return new Promise(() => { });
    }
    /**
     * This is a no-op in SSR mode.
     */
    triggerCrudUpload() { }
    /**
     * No-op in SSR mode.
     */
    updateSubscriptions() { }
    /**
     * No-op in SSR mode.
     */
    markConnectionMayHaveChanged() { }
    requestCheckpoint() {
        throw new Error('Sub sync implementation does not support request checkpoints');
    }
}
//# sourceMappingURL=SSRWebStreamingSyncImplementation.js.map